import React, { useState, useEffect } from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Loader from "./Loader";

const CircularProgressBar = ({ percentage, img }) => {
  const [animatedPercentage, setAnimatedPercentage] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isIconLoading, setIsIconLoading] = useState(true);

  useEffect(() => {
    let interval = null;
    if (isHovered) {
      interval = setInterval(() => {
        setAnimatedPercentage((prevPercentage) => {
          if (prevPercentage < percentage) {
            return prevPercentage + 5;
          } else {
            clearInterval(interval);
            return percentage;
          }
        });
      }, 20);
    }
    return () => clearInterval(interval);
  }, [isHovered, percentage]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setAnimatedPercentage(0);
  };
  const handleIcon = () =>{
    setIsIconLoading(false);
  }

  const getGradientColors = () => {
    return (
      <linearGradient id="linearGradient" gradientTransform="rotate(90)">
        <stop offset="0%" stopColor="#00b050" />
        <stop offset="33%" stopColor="#f6e200" />
        <stop offset="66%" stopColor="#f97316" />
        <stop offset="100%" stopColor="#c40000" />
      </linearGradient>
    );
  };

  return (
    <div
      className={`w-20 h-20 mb-6 px-0.5 py-0.5 rounded-full mr-3 bg-transparent sm:text-sm sm:px-2 sm:py-1`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <svg style={{ height: 0 }}>
        <defs>{getGradientColors()}</defs>
      </svg>
      <CircularProgressbarWithChildren
        value={animatedPercentage}
        styles={buildStyles({
          pathColor: `url(#linearGradient)`,
          textColor: "#ffffff",
        })}
      >
        {isIconLoading && <Loader/>}
        <img onLoad={handleIcon} src={img} alt="skill" style={{ width: 30, height: 30 }} />
        <div className="progress-text">{`${animatedPercentage}%`}</div>
      </CircularProgressbarWithChildren>
      <style jsx>{`
        .progress-text {
          display: none;
          color: #ffffff;
        }
        .w-20:hover .progress-text {
          display: block;
        }
      `}</style>
    </div>
  );
};

export default CircularProgressBar;
